module.exports = __webpack_public_path__ + "top_page/img-novelty-item-cf47317e9c2143a5d7fe35dacd07f0a2.png";